module.exports = __webpack_public_path__ + "static/media/30-4.109d87d1.mp3";